/* eslint-disable camelcase */
import React, { useMemo } from "react";
import { Link } from "react-router";
import { Spin, Divider } from "antd";
import { IndependentDynamicForm } from "@companion-core/shared/app/Components/DynamicForm/IndependentDynamicForm";
import { ValidationBanner } from "@companion-core/shared/app/Components/ValidationBanner";
import { WizardStoreProvider } from "@companion-core/shared/app/Store/wizardStore";
import { useMemberStore } from "@companion-core/shared/app/Store/memberStore";
import { useAccountNavigationStore } from "@companion-core/shared/app/Store/accountNavigationStore";
import { JPInput } from "@companion-core/shared/app/Components/Inputs/JPInput";
import { trackClickHelp } from "@companion-core/shared/app/tracking/myaccount";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useSecurity } from "./hooks/security";
import "@companion-core/web/src/Assets/Styles/scss/security.scss";

export const Security = () => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const {
    isMemberFetching,
    dataMember,
    securityConfig,
    enabledModulesCount,
    jsonForms,
    isPendingChangeSecret,
    isPendingChangePassword,
    t,
    onSubmitChangeSecretForm,
    onSubmitChangePasswordForm,
  } = useSecurity();
  const { validationStatus, validationMessage } = useMemberStore();
  const { closePopover } = useAccountNavigationStore();

  const showTitle = useMemo(
    () => isMobileSize || enabledModulesCount <= 1,
    [isMobileSize, enabledModulesCount],
  );
  return isMemberFetching || isPendingChangeSecret || isPendingChangePassword ? (
    <Spin className="my-account-security__spin" size="large" />
  ) : (
    <WizardStoreProvider>
      <div data-testid="my-account-security" className="my-account__section my-account-security">
        {showTitle && (
          <h1
            data-testid="my-account-security__title"
            className="my-account__section-title super-title-3 my-account-security__title">
            {t("my-account.security.title")}
          </h1>
        )}

        <div className="my-account__section-content my-account-security__section">
          <ValidationBanner
            testID={`my-account-security__status-${validationStatus}`}
            className="my-account__validation-banner"
            visible={!!validationStatus}
            text={validationMessage ?? ""}
            type={validationStatus ?? "success"}
            autoFadeOut
            fadeOutDelay={10000}
          />
          <div className="my-account-security__change-username">
            <h2 className="my-account-security__form-title body-text-3">
              {t("my-account.security.username.title")}
            </h2>
            <div className="my-account-security__change-username-label body-text-6">
              <span>{t("my-account.security.username.link.pre")}</span>
              <br />
              <Link
                data-testid="my-account-security__link-need-help"
                to="/need-help"
                className="body-text-5"
                onClick={() => {
                  trackClickHelp();
                  if (isMobileSize) closePopover();
                }}>
                {t("my-account.security.username.link.link")}
              </Link>
            </div>
            <JPInput
              name="username"
              testID="my-account-security__username"
              type="text"
              value={dataMember?.username ?? ""}
              disabled
            />
          </div>
          <Divider />
          {securityConfig?.forms?.changeSecret && (
            <>
              <h2 className="my-account-security__form-title body-text-3">
                {t("my-account.security.change-secret.title")}
              </h2>
              <IndependentDynamicForm
                name="changeSecret"
                initialFormJSON={jsonForms.baseJsonChangeSecret}
                onSubmitForm={onSubmitChangeSecretForm}
              />
              <Divider />
            </>
          )}
          <h2 className="my-account-security__form-title body-text-3">
            {t("my-account.security.change-password.title")}
          </h2>
          <IndependentDynamicForm
            name="changePassword"
            initialFormJSON={jsonForms.baseJsonChangePassword}
            onSubmitForm={onSubmitChangePasswordForm}
          />
        </div>
      </div>
    </WizardStoreProvider>
  );
};
